import { render, staticRenderFns } from "./TablePaginationFooter.vue?vue&type=template&id=16de9120&scoped=true"
import script from "./TablePaginationFooter.vue?vue&type=script&lang=js"
export * from "./TablePaginationFooter.vue?vue&type=script&lang=js"
import style0 from "./TablePaginationFooter.vue?vue&type=style&index=0&id=16de9120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de9120",
  null
  
)

export default component.exports